import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-payoneer',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Payoneer icon</title><path d="M1.474 3.31c.234 1.802 1.035 5.642 1.398 7.263.095.459.201.853.298 1.013.501.865.907-.287.907-.287C5.644 6.616 3.17 3.597 2.38 2.787c-.139-.15-.384-.332-.608-.396-.32-.095-.374.086-.374.236.01.148.065.565.075.682zm21.835-1.463c.31.224 1.386 1.355 0 1.526-1.984.234-5.76.373-12.022 5.61C8.92 10.968 3.607 16.311.76 22.957a.181.181 0 01-.216.106c-.255-.074-.714-.352-.48-1.418.32-1.44 3.201-8.938 10.817-15.552 2.485-2.155 8.416-7.232 12.426-4.245z"/></svg>`,
    styles: []
})
export class SimpleIconsPayoneerComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FF4800';
    @Input() className: string = 'simple-icons-payoneer'
    constructor() {}
    ngOnInit(): void {}
}
